module.exports = __webpack_public_path__ + "img/[拥抱].45df918c.svg";